import { locations } from '../data/locations.js';
import { AppSyncBase } from './app_sync_base.js';
import { log } from './logger.js';

/**
 * Web socket mechanism to keep locations updated when server data is changed.
 */
class AppSyncLoc extends AppSyncBase {
  on({ id, type, data }) {
    let locId = parseInt(id);
    switch (type) {
      case this.messages.connected:
        return this.onConnected(locId);

      case this.messages.availabilityUpdate:
        return this.onAvailabilityUpdate(locId, data);

      default:
        break;
    }
  }

  onConnected(locId) {
    log(`[ws] reload availability for loc:${locId}`);
    return locations.get(locId)?.reloadAvailability();
  }

  onAvailabilityUpdate(locId, data) {
    log(`[ws] onAvailabilityUpdate for loc:${locId}`);
    return locations.get(locId)?.setAvailability(data);
  }

  get messages() {
    if (!this.#messages) {
      this.#messages = Object.assign({}, super.messages, {
        availabilityUpdate: 'availability-update',
      });
    }
    return this.#messages;
  }

  get pipeType() {
    return 'loc';
  }

  #messages;
}

export { AppSyncLoc };
